import { styled } from "styled-components";
import { Card } from "styles/mixinStyles";

const LinkCardContainer = styled(Card)`
  background-color: #CCCCFF;
  width: 90vw;
  margin-bottom: 2vw;
  overflow: hidden;
  h2 {
    width: 30vw;
  }
  div {
    width: 50vw;
    p {
      font-weight: 700;
      margin-right: 2rem;
    }
  }
`;

export { LinkCardContainer };

